<template>
  <div class="body_box_wrap">
    <!-- <div style="display: flex;justify-content: flex-end;">
      <el-button
        type="primary"
        style="position: relative;top: 25PX;cursor: pointer;"
        @click="goback()"
      >返回</el-button>
      <el-button
        :disabled="getPdfStatus"
        type="primary"
        style="position: relative;top: 25PX;cursor: pointer;"
        @click="getPdf()"
      >导出PDF</el-button>
    </div> -->
    <div style="border:1PX solid #000;margin-left:-5PX;margin-top:50PX;">
      <div id="pdfDom" class="box_wrap">
        <div class="box_top">
          <h1 class="top_report">黄浦区消防物联网服务商</h1>
          <h1 class="top_report">综合质量评分报告</h1>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box" style="margin: 300PX auto;height: 654PX;">
            <tr style="background: #D8D8D8;">
              <td class="labstyle" colspan="2">评分数据</td>
            </tr>
            <tr>
              <td class="labstyle">受评单位</td>
              <td class="type1">{{ companyData.o_name }}</td>
            </tr>
            <tr>
              <td class="labstyle">受评月份</td>
              <td class="type1">{{ $format_time(detailData.score_time, 'YYYY-MM') }}</td>
            </tr>
            <tr>
              <td class="labstyle">评估得分</td>
              <td class="type1" style="font-weight: 600; color: #0070C0;">{{ companyData.total_score }} 分</td>
            </tr>
            <tr>
              <td class="labstyle">评估周期</td>
              <td class="type1">按自然月评估</td>
            </tr>
            <tr>
              <td class="labstyle">数据来源</td>
              <td class="type1">黄浦消防重大安保平台</td>
            </tr>
            <tr>
              <td class="labstyle">评估机构</td>
              <td class="type1">黄浦区应急消防救援支队</td>
            </tr>
            <tr>
              <td class="labstyle">评估日期</td>
              <td class="type1">{{ $format_time(companyData.score_time) }}</td>
            </tr>
            <tr>
              <td class="labstyle">评估标准</td>
              <td>
                <div v-show="accessRate" class="type1">● 系统接入率</div>
                <div v-show="integrity" class="type1">● 业务数据完整性</div>
                <div v-show="quality" class="type1">● 业务数据质量</div>
                <div v-show="stable" class="type1">● 平台稳定性</div>
                <div v-show="devAccProportion" class="type1">● 接入建筑群设备占比</div>
                <div v-show="serviceRate" class="type1">● 服务质量调研</div>
              </td>
            </tr>
            <!-- <tr>
              <td class="labstyle">办公地址</td>
              <td class="type1">{{ companyData.o_address }}</td>
            </tr> -->
            <tr>
              <td colspan="2" style="height: 50PX;">
                备注：历史报告数据已存档，后期调整评分方案不会变更报告数据
              </td>
            </tr>
          </table>
        </div>
        <div style="padding-bottom:50PX;">
          <h2 class="top_report" style="margin-top: 250PX;">评估报告详情</h2>
          <div class="box_jieru small">
            <h3 class="box_title">一、服务商信息</h3>
            <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box" style="margin: 20PX auto;">
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="2">服务商基本信息</td>
              </tr>
              <tr>
                <td class="labstyle">单位名称</td>
                <td>{{ companyData.o_name }}</td>
              </tr>
              <tr>
                <td class="labstyle">法人代表</td>
                <td>{{ companyData.legal_name }}</td>
              </tr>
              <tr>
                <td class="labstyle">联系人</td>
                <td>{{ companyData.o_linkman }}</td>
              </tr>
              <tr>
                <td class="labstyle">联系人电话</td>
                <td>{{ companyData.o_linkphone.substring(0,3) + "****" + companyData.o_linkphone.substring(7) }}</td>
              </tr>
              <tr>
                <td class="labstyle">统一信用代码</td>
                <td>{{ companyData.o_license }}</td>
              </tr>
              <tr>
                <td class="labstyle">注册地址</td>
                <td>{{ companyData.reg_address }}</td>
              </tr>
              <tr>
                <td class="labstyle">办公地址</td>
                <td>{{ companyData.o_address }}</td>
              </tr>
              <tr>
                <td class="labstyle">管理建筑群</td>
                <td> {{ companyData.buildGroupnums }} </td>
              </tr>
              <tr>
                <td class="labstyle">管理楼宇</td>
                <td>{{ companyData.buildnums }}</td>
              </tr>
            </table>
          </div>
          <div class="box_jieru small">
            <h3 class="box_title" style="padding-top: 100PX;">二、评分说明</h3>
            <!-- <div class="explainline">物联网服务商综合质量评分，主要从以下5个维度进行评分：</div>

            <div class="explainline">1.系统接入率：按照应接必接原则，需要按照主管单位要求上报数据；</div>

            <div class="explainline">2.业务数据完整性：通过及时上报业务数据，用以评估物联网服务商平台业务功能完整性；</div>

            <div class="explainline">3.业务数据质量：通过统计一定周期内设备上报数据次数评估；</div>

            <div class="explainline">4.平台稳定性：通过持续时间段内离线率判断系统稳定性；</div>

            <div class="explainline">5.服务质量调研：通过微信小程序向重点单位进行数据调研评估。</div> -->
            <div class="explainline">
              物联网服务商综合质量评分，主要是通过以下<span style="color: #FF370F;">{{ getNum() }}</span>个模块及多项指标进行统计分析一段时间内服务商综合服务质量。特别注意，所有考核建筑中，无设备服务商，考核总分为0，即使有建筑单位信息，总分也为0。
            </div>

          </div>
          <div class="box_jieru small" style="height: 1400PX;margin-bottom:150PX;">
            <h3 class="box_title" style="padding-top: 200PX;">三、评分数据</h3>
            <table v-if="accessRate" border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="4">系统接入率</td>
              </tr>
              <tr>
                <td colspan="4" style="height: 50PX;text-align:left;">
                  <!-- <div class="explainline">
                  1. 按照“应接必接”原则，各服务商应该具备向主管单位数据中心接入消防系统能力，并上报数据；
                  </div>
                  <div class="explainline">
                    2. 该项无评分周期要求，每接入一项指标计1分
                    </div> -->
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      按照“应接必接”原则，各服务商应该具备向主管单位数据中心接入消防系统能力，并上报数据；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      该项无评分周期要求，每接入一项指标计1分；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">对接系统</td>
                <td class="labstyle">指标</td>
                <td class="labstyle">接入时间</td>
                <td class="labstyle">业务状态</td>
              </tr>
              <tr v-for="(item, index) in accessRate" :key="index">
                <td
                  v-if="objectSpanMethod('accessRate',item, index, true)"
                  :rowspan="objectSpanMethod('accessRate',item, index, true)"
                >{{ item.system_name }}</td>
                <td
                  v-if="objectSpanMethod('accessRate',item, index, false)"
                  :rowspan="objectSpanMethod('accessRate',item, index, false)"
                >{{ item.name }}</td>
                <td
                  v-if="objectSpanMethod('accessRate',item, index, false)"
                  :rowspan="objectSpanMethod('accessRate',item, index, false)"
                >{{ item.time ? $format_time(item.time) : '/' }}</td>
                <td
                  v-if="objectSpanMethod('accessRate',item, index, false)"
                  :rowspan="objectSpanMethod('accessRate',item, index, false)"
                  :style="{color: item.isPass ? '#29CC5F' : '#CC4429'}"
                >{{ item.isPass ? '已接入' : '未接入' }}</td>
              </tr>
            </table>
          </div>
          <div class="box_jieru small whole" style="height: 334PX;">
            <!-- <h3 class="box_title" style="padding-top:100PX;">四、软件平台的业务数据合规性</h3> -->
            <table v-if="integrity" border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="4">业务数据完整性</td>
              </tr>
              <tr>
                <td colspan="4" style="height: 50PX;text-align:left;">
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      服务商平台应该满足接入建筑各项业务数据上报，不限于日常火警业务、故障业务等日常运维数据上报到数据中心，以备查阅评估建筑单位日常消防安全管理工作；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      评分周期内有上报数据表示合格；未上报数据得0分；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">指标</td>
                <td class="labstyle">最后一次上报时间</td>
                <td class="labstyle">未上报持续时间</td>
                <td class="labstyle">业务状态</td>
              </tr>
              <tr v-for="(item, index) in integrity" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.lastTime?dayjs.unix(item.lastTime).format('YYYY-MM-DD HH:mm:ss'):'/' }}</td>
                <td>{{ item.lastTime?DateDifference(item.lastTime*1000, new Date()) :'/' }}</td>
                <td
                  :style="{color: item.isPass ? '#29CC5F' : '#CC4429'}"
                >{{ item.isPass ? '合格' : '不合格' }}</td>
              </tr>
            </table>
          </div>
          <div class="box_jieru small" style="margin-bottom:20PX;padding-top: 100PX;">
            <!-- <h3 class="box_title">五、软件平台的连接稳定性</h3>
            <div style="margin-bottom:20PX;font-size:16PX;">服务商的二级平台应稳定、真实的向数据中心提交数据</div> -->
            <table v-if="quality" border="1" align="center" cellpadding="0" cellspacing="0" class="table_box" style="height: 784PX;margin-bottom: 200PX;">
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="4">业务数据质量</td>
              </tr>
              <tr>
                <td colspan="4" style="height: 50PX;text-align:left;">
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      建筑单位已接入系统，服务商有义务按照实际情况及时、准确向数据中心上报数据，以备查阅和评估建筑单位日常消防安全管理工作；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      评分周期（按天计算）内有上报数据表示合格，每合格一项计1分；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">系统名称</td>
                <td class="labstyle">指标</td>
                <td class="labstyle">考核周期已上报数</td>
                <td class="labstyle">周期上报率</td>
              </tr>
              <tr v-for="(item, index) in quality" :key="index">
                <td
                  v-if="objectSpanMethod('quality',item, index, true)"
                  :rowspan="objectSpanMethod('quality',item, index, true)"
                >{{ item.system_name }}</td>
                <td
                  v-if="objectSpanMethod('quality',item, index, false)"
                  :rowspan="objectSpanMethod('quality',item, index, false)"
                >{{ item.name }}</td>
                <td
                  v-if="objectSpanMethod('quality',item, index, false)"
                  :rowspan="objectSpanMethod('quality',item, index, false)"
                >{{ item.reportNum }}</td>
                <td
                  v-if="objectSpanMethod('quality',item, index, false)"
                  :rowspan="objectSpanMethod('quality',item, index, false)"
                >{{ accMul(item.reportPro, 100) + '%' }}</td>
              </tr>
            </table>
            <table
              v-if="stable"
              border="1"
              align="center"
              cellpadding="0"
              cellspacing="0"
              class="table_box"
              style="margin-bottom:30PX;height: 320PX;"
            >
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="3">平台稳定性</td>
              </tr>
              <tr>
                <td colspan="3" style="height: 50PX;text-align:left;">
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      通过一定周期内设备离线时长和设备离线数量，判断服务商平台稳定性；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      评分周期内，如离线率大于{{ qualityscore_stable }}%，该模块考核不得分，其他情况按公式计算；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">指标</td>
                <td class="labstyle">系统数据</td>
                <td class="labstyle">离线率</td>
              </tr>
              <tr>
                <td>设备离线时长</td>
                <td>
                  <div>
                    服务商设备总数：{{ stable.total_devnum ? stable.total_devnum : 0 }} 个
                  </div>
                  <div>
                    服务商设备离线总时长：{{ stable.total_offlinetime ? $difftime(stable.total_offlinetime * 3600) : 0 }}
                    <!-- 服务商设备离线总时长：{{ $difftime(33* 3600)  }} -->
                  </div>
                </td>
                <td>{{ accMul(stable.devOff_time, 100) }}%</td>
              </tr>
              <tr>
                <td>设备离线数量</td>
                <td>
                  <div>
                    服务商设备总数：{{ stable.total_devnum ? stable.total_devnum : 0 }} 个
                  </div>
                  <div>
                    设备离线总数量：{{ stable.dev_offline_num ? stable.dev_offline_num : 0 }} 个
                  </div>
                </td>
                <td>{{ accMul(stable.offline_num, 100) }}%</td>
              </tr>
            </table>
            <table
              v-if="devAccProportion"
              border="1"
              align="center"
              cellpadding="0"
              cellspacing="0"
              class="table_box"
              style="margin-bottom:30PX;height: 314PX;"
            >
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="3">接入建筑群设备占比</td>
              </tr>
              <tr>
                <td colspan="3" style="height: 50PX;text-align:left;">
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      按照“应接必接”原则，各服务商应该按照建筑群实际情况，充分接入物联网设备，确保覆盖率；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      考核项通过计算服务商建筑群平均设备与平台所有建筑群平均设备对比，按排名计算分值；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">指标</td>
                <td class="labstyle">系统数据</td>
                <td class="labstyle">占比率</td>
              </tr>
              <tr>
                <td>服务商建筑群平均设备占比</td>
                <td>
                  <!-- 建筑群: {{ devAccProportion.pnum }}接入设备: {{ devAccProportion.devnum }} -->
                  <div>
                    该服务商建筑群平均设备: {{ devAccProportion.companyAvg ? devAccProportion.companyAvg : 0 }} 个
                  </div>
                  <div>
                    平台所有建筑群平均设备：{{ devAccProportion.avg_dev ? devAccProportion.avg_dev : 0 }} 个
                  </div>
                </td>
                <td>{{ accMul(devAccProportion.percentage, 100) }}%</td>
              </tr>
            </table>
            <table
              v-if="serviceRate"
              border="1"
              align="center"
              cellpadding="0"
              cellspacing="0"
              class="table_box"
              style="margin-bottom:30PX;"
            >
              <tr style="background: #D8D8D8;">
                <td class="labstyle" colspan="3">服务质量评分</td>
              </tr>
              <tr>
                <td colspan="3" style="height: 80PX;text-align:left;">
                  <ul>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      通过微信小程序向建筑单位进行问卷调研，获得服务商质量评分数据；调研包含三项内容：①软件平台稳定性 ②业务相应及时性 ③综合服务满意度；
                    </li>
                    <li class="explainline" style="list-style: auto!important;margin-left: 30PX;">
                      该项需要后台配置考核；
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td class="labstyle">服务商名称</td>
                <td class="labstyle">调研总分</td>
                <td class="labstyle">评分值</td>
              </tr>
              <tr>
                <td>无</td>
                <td>无</td>
                <!-- <td
                  :style="{color: stable.isPass ? '#29CC5F' : '#CC4429'}"
                >{{ stable.isPass ? '合格' : '不合格' }}</td> -->
                <td
                  :style="{color: stable.isPass ? '#29CC5F' : '#CC4429'}"
                />
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// import { rateArchivesDetail } from '@/api/markingsystem'
import { wordbooksearch, rateArchivesDetail } from '@/api/gov'
import dayjs from 'dayjs'
export default {
  name: 'Exportpdf',
  props: {
    detailData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      qualityscore_stable: null,
      dangerSourceMap: {},
      prod: process.env.ENV_SERVER,
      htmlTitle: '接入质量报告',
      getPdfStatus: true,
      dayjs: dayjs,
      buildingData: {
        building_name: '',
        report_code: '',
        report_time: '',
        report_end_time: '',
        report_status: 0,
        ctrlroom_phone: '',
        employeeList: [],
        buildingAddress: [],
        keyPartList: []
      },
      beianReport: {
        address: 0,
        phone: 0,
        buildNum: 0,
        keyImages: 0,
        planImages: 0,
        deviceEnter: 0,
        pointImport: 0
      },
      eventReport: {
        eventData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        taskData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        sheetData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        sheetProportion: {
          proportion: 0,
          taskSheetNum: 0,
          sysconfig: 0.01,
          isPass: 0
        },
        stable: {
          deviceNum: 0,
          offlineNum: 0,
          proportion: 0,
          sysconfig: 0.01,
          isPass: 0
        }
      },
      accessRate: [],
      quality: [],
      stable: {
        proportion: 5,
        deviceNum: 0,
        offlineNum: 0,
        offlineRate: 0,
        isPass: 0
      },
      serviceRate: [],
      devAccProportion: {
        devnum: 0,
        percentage: 0,
        pnum: 0
      },
      standard: [],
      companyData: {
        now_time: '',
        report_time: '',
        report_status: 0,
        passPercent: '0',
        o_name: '',
        o_linkman: '',
        o_linkphone: '',
        o_license: '',
        legal_name: '',
        reg_address: '',
        o_address: ''
      },
      integrity: []
    }
  },
  watch: {
    detailData: function(val) {
      this.getrateArchivesDetail()
    }
  },
  mounted() {
    this.getrateArchivesDetail()
  },
  created() {
    this.wordbooksearch('qualityscore_stable')
  },
  methods: {
    wordbooksearch(str) {
      wordbooksearch({ keyname: str }).then(res => {
        if (res.data.code === 0) {
          console.log('resresres', res)
          const obj = res.data.data[0]
          // this.wordbookdata = obj
          this.qualityscore_stable = obj.display
        }
      })
    },
    accMul(arg1, arg2) {
      return Math.floor(arg1 * arg2)
      // if (!arg1) {
      //   return '0'
      // }
      // let m = 0
      // const s1 = arg1.toString()
      // const s2 = arg2.toString()
      // m += s1.split('.')[1].length
      // m += s2.split('.')[1].length
      // return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },
    getNum() {
      let count = 0
      if (this.integrity) {
        count++
      }
      if (this.accessRate) {
        count++
      }
      if (this.quality) {
        count++
      }
      if (this.stable) {
        count++
      }
      if (this.serviceRate) {
        count++
      }
      if (this.devAccProportion) {
        count++
      }
      return count
    },
    goback() {
      this.$emit('goback')
    },
    getrateArchivesDetail() {
      rateArchivesDetail({ id: this.detailData.cid, time: this.detailData.score_time, status: this.detailData.status }).then(res => {
        console.log(res.data)
        if (res.code === 0) {
          const reportData = res.data
          this.companyData = reportData.companyData ? reportData.companyData : null
          this.integrity = reportData.integrity ? reportData.integrity : null
          this.accessRate = reportData.accessRate ? reportData.accessRate : null
          this.quality = reportData.quality ? reportData.quality : null
          this.stable = reportData.stable ? reportData.stable : null
          this.serviceRate = reportData.serviceRate ? reportData.serviceRate : null
          this.devAccProportion = reportData.devAccProportion ? reportData.devAccProportion : null
        } else {
          this.$emit('goback')
          this.$message.error('数据异常')
        }
        this.$nextTick(() => {
          this.htmlTitle = this.companyData.o_name + '-综合质量评分报告'
          this.getPdfStatus = false
          this.getSmall()
        })
      })
    },
    getRemark(value) {
      if (value) {
        var valueArr = value.split(',')
        var newArr = []
        for (const item of valueArr) {
          const name = this.dangerSourceMap[item]
          newArr.push(name)
        }
        return newArr.join('，')
      } else {
        return ''
      }
    },
    objectSpanMethod(list, row, rowIndex, type) {
      let arr = []
      if (list) {
        arr = this[list]
      } else {
        arr = this.accessRate
      }
      if (type) {
        var num = 0
        for (var i = 0; i < arr.length; i++) {
          if (row.system_id === arr[i].system_id) {
            num++
          }
        }
        if (num === 1) {
          return num
        } else if (num > 1) {
          if (
            arr[rowIndex - 1] &&
            arr[rowIndex].system_id === arr[rowIndex - 1].system_id
          ) {
            return 0
          } else {
            return num
          }
        }
      } else {
        return 1
      }
    },
    queryReportStatus(value) {
      var status = '未接入'
      switch (value) {
        case 0:
          status = '未接入'
          break
        case 1:
          status = '缺陷中'
          break
        case 2:
          status = '已合格'
          break
      }
      return status
    },
    // *重复使用可以将方法单独提取js文件中，然后在页面通过import使用，此处不再概述
    getSmall() {
      const num = 1440
      const dom = document.getElementsByClassName('small')
      console.log('dom', dom)
      for (var i = 0; i < dom.length - 1; i++) {
        const smallBottom = dom[i].offsetTop + dom[i].offsetHeight
        const smallBottomTwo = dom[i + 1].offsetTop + dom[i + 1].offsetHeight
        console.log(
          i,
          smallBottom,
          smallBottomTwo,
          smallBottomTwo - smallBottom
        )
        if (i === 1) {
          console.log(dom[i + 1], dom[i + 1].offsetHeight)
        }
        if ((smallBottom % num) + (smallBottomTwo - smallBottom) > num) {
          // 判断A元素距离页面顶部的高度与A+1元素高度的和是否超出一页的高度
          dom[i].style.marginBottom = num + 50 - (smallBottom % num) + 'Px'
          // this.getSmall();
          // return
        }
      }
    },
    DateDifference(creattime, endtime) {
      var begin = new Date(creattime)
      var end = new Date(endtime)
      // 时间相差毫秒数
      var span = end.getTime() - begin.getTime()
      if (span > 0) {
        // 计算相差天数
        var result = ''
        var days = Math.floor(span / (24 * 3600 * 1000))
        if (days > 0) {
          result += days + '天'
        }
        // 相差小时数
        var leave1 = span % (24 * 3600 * 1000)
        var hours = (
          Array(2).join(0) + Math.floor(leave1 / (3600 * 1000))
        ).slice(-2)
        if (hours > 0) {
          result += hours + '小时'
        }
        // 相差分钟
        var leave2 = leave1 % (3600 * 1000)
        var minutes = (
          Array(2).join(0) + Math.floor(leave2 / (60 * 1000))
        ).slice(-2)
        if (!(days > 0)) {
          result += minutes + '分钟'
        }
        // 相差秒
        var level3 = leave2 % (60 * 1000)
        var seconds = (Array(2).join(0) + Math.round(level3 / 1000)).slice(-2)
        if (!(days > 0) && !(hours > 0)) {
          result += seconds + '秒'
        }
        // var time = days + ':' + hours + ':' + minutes + ':' + result
        return result
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.body_box_wrap {
  width: 1000PX;
  position: relative;
  margin: 0 auto;
  font-size: 18PX;
}
.box_wrap {
  width: 1000PX;
  margin-top: 50PX;
  margin-bottom: 50PX;
  border: 1PX solid #fff;
}
.box_top {
  height: 1220PX;
  // border-bottom: 1PX dashed #888888;
}
.top_title {
  text-align: center;
  padding-bottom: 40PX;
  margin-top: 200PX;
}
.top_report {
  text-align: center;
  padding-bottom: 10PX;
}
.top_bianhao {
  font-weight: bold;
  padding-bottom: 15PX;
  width: 400PX;
  padding-top: 500PX;
  margin: 0 auto;
}
.top_detail {
  width: 400PX;
  margin: 0 auto;
}
.top_detail_title {
  font-size: 20PX;
  font-weight: 500;
  padding: 10PX 0;
}
.top_detail_zhiliang {
  display: flex;
  font-size: 20PX;
  font-weight: 500;
  padding: 10PX 0;
}
.table_box {
  width: 800PX;
  text-align: center;
  margin-bottom: 50PX;
}
.table_box td {
  height: 50PX;
}
.table_one {
  width: 250PX;
}
.table_bottom {
  width: 100PX;
}
.box_jieru {
  padding: 0 100PX;
}
.whole{
  margin-bottom:50PX!important;
}
.box_title {
  padding-top: 60PX;
  padding-bottom: 20PX;
}
.labstyle {
  font-weight: 600;
  width: 240PX;
}
.type1 {
    text-align: left;
    padding-left: 30PX;
    height: 40PX;
    line-height: 40PX;
  }
  .explainline{
    font-size: 20PX;
    font-weight: 500;
    line-height: 30PX;
    padding: 10PX 0;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/basicComponents/exportpdf.vue